export default __webpack_public_path__ + "static/media/13.0ef66ecb.webp";